import Typography from "typography"

const typography = new Typography({
  baseFontSize: '18px',
  bodyWeight: '400',
  // boldWeight:'600',
  baseLineHeight: 1.45,
  headerFontFamily: ['Signika', 'sans-serif'],
  bodyFontFamily: ['Open Sans', 'sans-serif'],
  googleFonts: [
    {
      name: 'Open Sans',
      styles: [
        '400',
        '400i',
        '600',
        '600i',
        '700',
      ]
    },
    // {
    //   name: 'Roboto',
    //   styles: [
    //     '500',
    //     '700'
    //   ]
    // },
    {
      name: 'Signika',
      styles: [
        '300',
        '300i',
        '400',
        '400i',
        '700',
        // '700i',
        // '900'
      ]
    },
    {
      name: 'Reenie Beanie',
      styles: [
        '400',
      ]
    },
  ],
  headerColor: 'var(--color-headingFont)',
  bodyColor: 'var(--color-text)',
  headerWeight: '700',
  blockMarginBottom: '1rem',
  overrideStyles: () => ({
    'a': {
      textDecoration: "none",
      boxShadow: "none",
      border: "none",
      color: "var(--color-text)"
    },
    'a:hover, a:active': {
      color: "var(--color-text)"
    },
    'blockquote': {}
  }),
})

// // Hot reload typography in development.
if (process.env.NODE_ENV !== `production`) {
  typography.injectStyles()
}

export default typography
export const rhythm = typography.rhythm
export const scale = typography.scale
